module.exports = __webpack_public_path__ + "static/media/MiFID II Transparency Data MLA (3 Nov 2021 version).pdf?c1e78e91";


//////////////////
// WEBPACK FOOTER
// ./src/common/data/MiFID II Transparency Data MLA (3 Nov 2021 version).pdf
// module id = 724
// module chunks = 0